// extracted by mini-css-extract-plugin
export var indeterminate = "_57-5";
export var md = "_57-4";
export var semantic = "_57-6";
export var sm = "_57-3";
export var text = "_57-7";
export var toggleInput = "_57-0";
export var toggleSwitch = "_57-1";
export var xs = "_57-2";